module.exports = __webpack_public_path__ + "static/media/slider2023-01.c9412d3f.png";